module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0018.jpg?v=be5fb27d";